import { space } from "styled-system";
import styled from "styled-components";

const GridItem = styled.div`
  ${space}
  align-self: ${(props) => {
    return props.alignSelf || "start";
  }};
  grid-column-start: ${(props) => {
    return props.gridColumnStart;
  }};
  justify-self: ${(props) => {
    return props.justifySelf || "start";
  }};
`;

export default GridItem;
